import Vue from 'vue'
import Router from 'vue-router'
import SupportPage from '@/components/SupportPage'

Vue.use(Router)

export default new Router({
	mode: 'history',
	fallback: true,
	scrollBehavior () {
		return { x: 0, y: 0 }
	},
	routes: [
		{
			path     : '/:location?',
			name     : 'SupportPage',
			component: SupportPage
		}
	]
})
